import { API_URL_BASE, htmlElem, contentElem } from '../utils/globals';
import { addToSessionStorage, retrieveFromSessionStorage} from '../utils/utilsStorage';
import { setAjaxLoading, setAjaxComplete } from '../utils/ajaxLoaders';
import { removeChildNodes } from '../utils/removeChildNodes';
import { indexPage } from '../utils/indexPage';
import { updatePushState } from '../utils/updatePushState';
import { resetNavigation } from './navigation';

const fetchIndexPage = () => {
    const indexPageData = retrieveFromSessionStorage('indexPage');
    if (indexPageData !== null) {
        appendMediaContent(indexPageData[0].content.rendered, contentElem);
        updatePushState('index');
    } else {
        fetch(`${API_URL_BASE}/pages?slug=index`)
            .then((response) => response.json())
            .then((data) => {
                if (!data.length) {
                    return;
                }
                setAjaxLoading(htmlElem);
                appendMediaContent(data[0].content.rendered, contentElem);
                updatePushState('index');
                addToSessionStorage('indexPage', data);
            })
            .catch(err => console.log(err))
            .finally(() => {
                setAjaxComplete(htmlElem);
            });
    }
    indexPage();
}

htmlElem.addEventListener('click', (event) => {
    if (event.target.className.includes('menu__trigger')) {
        event.preventDefault();
        fetchIndexPage();
        resetNavigation();
    }
});

const appendMediaContent = (input, wrapper) => {
    removeChildNodes(contentElem);
    const parser = new DOMParser();
    const doc = parser.parseFromString(input ?? '', 'text/html');
    const video = doc.querySelector('video');
    const image = doc.querySelector('img');
    let template;
    if (video) {
        const videoSrc = video.getAttribute('src');    
        template = `
            <figure>
                <video
                    playsinline="playsinline"
                    muted="muted"
                    autoplay="true"
                    loop="true"
                >
                    <source src=${videoSrc} type="video/mp4">
                </video>
            </figure>
        `;
    } else if (image) {
        const imageSrc = image.getAttribute('src');    
        template = `
            <figure>
                <img src=${imageSrc}>
            </figure>
        `;
    } else {
        template = '';
    }
    wrapper.insertAdjacentHTML('beforeend', template);
}
 
export {
    fetchIndexPage
}